export default "__VITE_ASSET__C6J12YUn__"